module.exports = __webpack_public_path__ + "static/media/file-xml.813baa1e.svg";